// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dXRr","col":"styles_col__114z2"};